import React from "react";
import Header from "../Component/Header"

const PrivacyPolicy = () => {

    return (<>
    <Header/>
        <main className="bg-grey">
            <div class="container p-5">
                <h2>XPSurvey Privacy Policy</h2>
                <h5><u><strong>Effective Date:</strong> Apr 01, 2024</u></h5>

                <p>XPSurvey ("we," "us," or "our") respects your privacy and is committed to protecting the personal information you provide through our website, XPSurvey (https://www.xprssurvey.com) (the "Website"). This Privacy Policy describes the types of information we collect, how we use it, and the choices you have about your information.</p>

                <h6><u>1. Information We Collect:</u></h6>
                <p>We collect the minimum amount of data necessary to fulfill your survey requirements. This may include:</p>
                <ul>
                    <li>Information you provide directly through surveys, such as demographic data and answers to survey questions.</li>
                    <li>Information collected automatically, such as your IP address and browser type.</li>
                </ul>

                <h6><u>2. Use of Your Information:</u></h6>
                <p>We will not sell your data to any third party. However, we may use your information for the following purposes:</p>
                <ul>
                    <li>To administer and improve the Website and surveys.</li>
                    <li>To analyze survey results and conduct research.</li>
                    <li>To communicate with you about your surveys and other services.</li>
                    <li>To share your information with third parties for research or project purposes, but only after anonymizing the data.</li>
                </ul>

                <h6><u>3. Data Security:</u></h6>
                <p>We maintain reasonable security measures to protect your information from unauthorized access, disclosure, alteration, or destruction. However, no website or internet transmission is completely secure, and we cannot guarantee the security of your information.</p>

                <h6><u>4. Disclaimer:</u></h6>
                <p>While we strive to protect your privacy, we cannot guarantee that your information will never be used in a way that is inconsistent with this Privacy Policy due to factors beyond our control. We will not be responsible for any unauthorized use of your information by third parties.</p>

                <h6><u>5. Data Retention:</u></h6>
                <p>We will retain your information for as long as necessary to fulfill the purposes described in this Privacy Policy, unless a longer retention period is required or permitted by law. We also regularly delete old data.</p>

                <h6><u>6. Your Choices:</u></h6>
                <p>You have the right to access, correct, or delete your information. You can also opt out of receiving communications from us. To exercise any of these rights, please contact us at <a href="support@xprssurvey.com">support@xprssurvey.com</a></p>

                <h6><u>7. Children's Privacy:</u></h6>
                <p>The Website is not intended for children under 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us so we can delete it.</p>

                <h6><u>8. Changes to this Privacy Policy:</u></h6>
                <p>We may update this Privacy Policy from time to time. We will post any changes on the Website. We encourage you to review this Privacy Policy periodically for any updates.</p>

                <h6><u>9. Contact Us:</u></h6>
                <p>If you have any questions about this Privacy Policy, please contact us at <a href="support@xprssurvey.com">support@xprssurvey.com</a></p>
            </div>
        </main>
    </>)
}
export default PrivacyPolicy;